import type {
  GetStartedProgressContext,
  GetStartedProgressPayloadDto,
  GetStartedProgressRetryCommand,
} from '../models/getStartedProgress.types'

import { appHttp, unwrap } from '@/shared/http'

type ProgressHttp = Pick<typeof appHttp, 'get' | 'post'>
const OWNED = { suppressGlobalErrorHandler: true, meta: { suppressGlobalErrorHandler: true } }

export function getStartedProgressPath(context: GetStartedProgressContext): string {
  return `/accounts/${encodeURIComponent(context.accountId)}/workspaces/${encodeURIComponent(context.workspaceId)}/onboarding/progress/`
}

/** Transport only. Retry commands can be constructed solely by the feature-owned validator. */
export class GetStartedProgressApi {
  constructor(private readonly http: ProgressHttp = appHttp) {}

  async fetchProgress(
    context: GetStartedProgressContext,
    signal?: AbortSignal,
  ): Promise<GetStartedProgressPayloadDto> {
    const response = await this.http.get<GetStartedProgressPayloadDto>(
      getStartedProgressPath(context),
      { ...OWNED, ...(signal ? { signal } : {}) },
    )
    return unwrap(response)
  }

  async retry(
    context: GetStartedProgressContext,
    command: GetStartedProgressRetryCommand,
    signal?: AbortSignal,
  ): Promise<void> {
    await this.http.post(
      command.path,
      { workspace_id: context.workspaceId },
      { ...OWNED, ...(signal ? { signal } : {}) },
    )
  }
}

export const getStartedProgressApi = new GetStartedProgressApi()
